import {
  ArrayMinSize,
  IsAlpha,
  IsArray,
  IsEmail,
  IsOptional,
  MaxLength,
  MinLength,
  ValidateNested,
} from "class-validator";
import { Type } from "class-transformer";
import { AttributeDto } from "./userCreateValidation";

export class UserInputUpdate {
  @IsOptional()
  @IsEmail(undefined, { message: "Email is not valid" })
  public email?: string;

  @IsOptional()
  @IsAlpha(undefined, {
    message: "First Name must only contain letters",
  })
  @MinLength(2, {
    message: "First Name must be at least 2 characters long",
  })
  @MaxLength(50, {
    message: "First Name must be at most 50 characters long",
  })
  public firstName?: string;

  @IsOptional()
  @IsAlpha(undefined, {
    message: "Last Name must only contain letters",
  })
  @MinLength(2, {
    message: "Last Name must be at least 2 characters long",
  })
  @MaxLength(50, {
    message: "Last Name must be at most 50 characters long",
  })
  public lastName?: string;

  @IsOptional()
  @IsArray()
  @ArrayMinSize(1, { message: "At least one group must be specified" })
  public groups?: string[];

  @IsOptional()
  @IsArray()
  @ArrayMinSize(1, { message: "At least one role must be specified" })
  public roles?: string[];

  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => AttributeDto)
  public attributes?: AttributeDto[];
}
